/* eslint-disable react/no-unknown-property */
/* eslint-disable arrow-body-style */
import React from 'react';

export const DialerEndCall = ({ width = 24, height = 24, className = '' }) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clip-path="url(#clip0_42087_113010)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M20.8732 12.5735C21.0425 12.4042 21.1376 12.1745 21.1376 11.9351C21.1376 11.7033 21.0485 11.4808 20.8893 11.3132C18.416 9.13354 15.2322 7.93061 11.9348 7.9306C8.63744 7.9306 5.45367 9.13355 2.98036 11.3132C2.82115 11.4808 2.73206 11.7033 2.73206 11.9351C2.73206 12.1745 2.82719 12.4042 2.99652 12.5735L5.11807 14.6951L8.31859 13.3234L7.86664 11.5156C7.75267 11.0597 8.00741 10.5926 8.45238 10.4416C10.7108 9.67507 13.1589 9.67507 15.4173 10.4416C15.8623 10.5926 16.117 11.0597 16.0031 11.5156L15.5511 13.3234L18.7516 14.6951L20.8732 12.5735ZM22.9434 11.9351C22.9434 12.6535 22.6581 13.3424 22.1501 13.8504L19.5963 16.4042C19.3352 16.6653 18.9415 16.7411 18.6021 16.5957L14.133 14.6803C13.7256 14.5057 13.5052 14.0614 13.6127 13.6314L14.0402 11.9214C12.6564 11.5896 11.2133 11.5896 9.82948 11.9214L10.257 13.6314C10.3645 14.0614 10.144 14.5057 9.73671 14.6803L5.26755 16.5957C4.9282 16.7411 4.53449 16.6653 4.27342 16.4042L1.71962 13.8504C1.21163 13.3424 0.926249 12.6535 0.926248 11.9351C0.926249 11.2167 1.21163 10.5277 1.71962 10.0197C1.73253 10.0068 1.74584 9.99426 1.75952 9.98215C4.56641 7.49687 8.18581 6.12479 11.9348 6.12479C15.6839 6.12479 19.3033 7.49687 22.1102 9.98215C22.1238 9.99426 22.1372 10.0068 22.1501 10.0197C22.6581 10.5277 22.9434 11.2167 22.9434 11.9351Z"
        fill="#F3F4F6"
      />
    </g>
    <defs>
      <clipPath id="clip0_42087_113010">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
